import type { GeminiClient } from '../../client/gemini/index.js'
import type { OllamaClient } from '../../client/ollama/index.js'
import type { OpenaiClient } from '../../client/openai/index.js'
import { createGeminiAdapter } from './gemini.js'
import { createOllamaAdapter } from './ollama.js'
import { createOpenaiAdapter } from './openai.js'
import type { Providers } from './types.js'

export const availableProviders = ['openai', 'gemini', 'ollama'] as const

export interface ProviderClients {
  openaiClient: OpenaiClient
  geminiClient: GeminiClient
  ollamaClient: OllamaClient
}

export function createProviders({
  openaiClient,
  geminiClient,
  ollamaClient,
}: ProviderClients): Providers {
  return {
    openai: createOpenaiAdapter(openaiClient),
    gemini: createGeminiAdapter(geminiClient),
    ollama: createOllamaAdapter(ollamaClient),
  }
}
